import { render, staticRenderFns } from "./SiteAdmin.vue?vue&type=template&id=6c6b5484&scoped=true&"
import script from "./SiteAdmin.vue?vue&type=script&lang=ts&"
export * from "./SiteAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./SiteAdmin.vue?vue&type=style&index=0&id=6c6b5484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b5484",
  null
  
)

export default component.exports